import React from "react";

export default function ColumnProfile({ data }) {
  if (!data || data.length === 0) return null;

  const columns = Object.keys(data[0]);

  const profiles = columns.map(col => {
    const values = data.map(row => row[col]);
    const nonNull = values.filter(v => v !== null && v !== undefined && v !== "");
    const unique = new Set(nonNull);

    return {
      col,
      count: values.length,
      missing: values.length - nonNull.length,
      uniqueCount: unique.size,
      sample: nonNull.slice(0, 3).join(", ") || "(empty)"
    };
  });

  return (
    <div
      style={{
        marginTop: 30,
        padding: "20px",
        background: "white",
        borderRadius: "12px",
        boxShadow: "0px 3px 8px rgba(0,0,0,0.08)",
        border: "1px solid #eee"
      }}
    >
      <h3 style={{ marginBottom: 15 }}>📊 Column Profiling Summary</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ background: "#f7f7f7", borderBottom: "2px solid #ddd" }}>
            <th style={{ padding: "10px", textAlign: "left" }}>Column</th>
            <th style={{ padding: "10px" }}>Total</th>
            <th style={{ padding: "10px" }}>Missing</th>
            <th style={{ padding: "10px" }}>Unique</th>
            <th style={{ padding: "10px" }}>Sample Values</th>
          </tr>
        </thead>

        <tbody>
          {profiles.map((p, i) => (
            <tr
              key={i}
              style={{
                background: i % 2 === 0 ? "#ffffff" : "#fafafa",
                borderBottom: "1px solid #eee",
              }}
            >
              <td style={{ padding: "10px" }}>{p.col}</td>
              <td style={{ padding: "10px" }}>{p.count}</td>

              <td
                style={{
                  padding: "10px",
                  color: p.missing > 0 ? "#d32f2f" : "#388e3c",
                  fontWeight: "bold"
                }}
              >
                {p.missing}
              </td>

              <td style={{ padding: "10px" }}>{p.uniqueCount}</td>

              <td style={{ padding: "10px", color: "#555" }}>{p.sample}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
